import React, { Component } from 'react';
import { IconButton, Stack, TextField, Toggle, CommandBarButton, FontIcon } from 'office-ui-fabric-react';
import { TooltipHost } from '@fluentui/react/lib/Tooltip';
import { MyContext } from '../../../../context';
import ScorecardFolding from '../../../DetailView/DetailPivot/PivotElements/QualityManagement/ScorecardFolding';
import EditScorecardSectionEvaluation from './EditScorecardSectionEvaluation';

export default class EditScorecardSection extends Component {

    static contextType = MyContext

    constructor(props) {
        super(props);
        this.state = {
            selectedKeyEvaluation: [],
            selectCriteria: null
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.section.evaluationItems.length !== this.props.section.evaluationItems.length) {
            this.setState({ selectedKeyEvaluation: [this.props.section.evaluationItems.length - 1] })
        }
    }

    deleteSection = (e) => {
        this.props.updateSection(null, this.props.indexSection, "delete")
    }

    deleteEvaluation = (indexEvaluation) => {
        const newSection = {
            ...this.props.section,
            evaluationItems: this.props.section.evaluationItems.filter((item, j) => indexEvaluation !== j)
        }
        this.props.updateSection(newSection, this.props.indexSection, "update")
    }

    updateSectionField = (e, field) => {
        const newSection = { ...this.props.section, [field]: e.target.value }
        this.props.updateSection(newSection, this.props.indexSection, "update")
    }

    updateEvaluationField = (value, indexEvaluation, field) => {
        const newSection = {
            ...this.props.section,
            evaluationItems: this.props.section.evaluationItems.map(
                (item, j) => {
                    if (j === indexEvaluation) {
                        if (field === "itemType") {
                            return { ...item, itemType: value, itemId: "", itemValue: "" }
                        } else {
                            return { ...item, [field]: value }
                        }
                    } else {
                        return item
                    }
                }
            )
        }
        this.props.updateSection(newSection, this.props.indexSection, "update")
    }

    changeIsMultiQuestions = (e, checked) => {
        const newSection = { ...this.props.section, isMultiQuestions: checked }
        this.props.updateSection(newSection, this.props.indexSection, "update")
    }

    render() {
        const isChecked = this.props.checkBoxSelected === null ? false : this.props.checkBoxSelected == this.props.indexSection
        const { section, indexSection } = this.props
        const isOpen = this.props.selectedKeySection.includes(this.props.indexSection)
        return (
            <Stack>
                <Stack horizontal horizontalAlign="space-between">
                    <Stack.Item>
                        <Stack horizontal>
                            <Stack.Item align="start">
                                <ScorecardFolding
                                    selectedKey={this.props.selectedKeySection}
                                    selected={this.props.indexSection}
                                    open={() => {
                                        this.props.updateSelectedKeySection([...this.props.selectedKeySection, indexSection])
                                    }}
                                    close={() => {
                                        this.props.updateSelectedKeySection(this.props.selectedKeySection.filter(s => s !== indexSection))
                                    }}
                                />
                            </Stack.Item>
                            <Stack.Item>
                                <IconButton
                                    iconProps={{ iconName: 'Delete' }}
                                    onClick={this.deleteSection} />
                            </Stack.Item>
                            {isOpen &&
                                <Stack.Item>
                                    <h5>{this.context.getTranslation("compliance", "section")}</h5>
                                </Stack.Item>
                            }
                            {!isOpen &&
                                <Stack.Item>
                                    <h5>{section.name != "" ? section.name : `${this.context.getTranslation("compliance", "section")}`}</h5>
                                </Stack.Item>
                            }
                            {this.props.automatedEvaluation && <TooltipHost
                                content={this.context.getTranslation("compliance", "sectionInfo")}
                                id={"info"}
                            >
                                <FontIcon iconName="Info" style={{ marginTop: "8px", marginLeft: "8px" }} />
                            </TooltipHost>}
                        </Stack>
                    </Stack.Item>

                    <Stack.Item align="end">
                        <Stack horizontal>
                            {this.props.automatedEvaluation && <Stack.Item style={{ marginTop: "5px" }} >
                                <Toggle
                                    onText={this.context.getTranslation("compliance", "groupQuestion")}
                                    offText={this.context.getTranslation("compliance", "singleQuestion")}
                                    checked={section.isMultiQuestions}
                                    onChange={this.changeIsMultiQuestions}
                                />
                            </Stack.Item>}
                            <Stack.Item >
                                <IconButton
                                    iconProps={{ iconName: 'Up' }}
                                    onClick={() => this.props.sortSections(this.props.section, this.props.indexSection, "up")} />
                                <IconButton
                                    iconProps={{ iconName: 'Down' }}
                                    onClick={() => this.props.sortSections(this.props.section, this.props.indexSection, "down")} />
                            </Stack.Item>
                        </Stack>


                    </Stack.Item>

                </Stack>
                {isOpen && <div>
                    <div style={{ marginLeft: "30px" }}>
                        <TextField
                            placeholder={this.context.getTranslation("compliance", "name")}
                            value={section.name}
                            onChange={(e) => this.updateSectionField(e, "name")}
                        />
                    </div>
                    {section.evaluationItems.length > 0 &&
                        <div style={{ marginLeft: "20px" }}>
                            {
                                //MANAGE EVALUATIONS
                                section.evaluationItems.map((evaluation, indexEvaluation) => {
                                    return (
                                        <EditScorecardSectionEvaluation
                                            key={"evaluation" + indexEvaluation}
                                            indexEvaluation={indexEvaluation}
                                            deleteEvaluation={this.deleteEvaluation}
                                            evaluation={evaluation}
                                            availableAreas={this.props.availableAreas}
                                            updateEvaluationField={this.updateEvaluationField}
                                            selectedKeyEvaluation={this.state.selectedKeyEvaluation}
                                            updateSelectedKeyEvaluation={(selectedKeyEvaluation) => {
                                                this.setState({ selectedKeyEvaluation })
                                            }}
                                        />
                                    )
                                })

                            }

                        </div>

                    }

                    <CommandBarButton style={{ marginLeft: "30px", marginTop: "20px", padding: "7px" }}
                        text={this.context.getTranslation("compliance", "addcriteria")}
                        iconProps={{ iconName: 'Add' }}
                        onClick={() => this.props.addEvaluation(this.props.section, this.props.indexSection)} />
                </div>}
            </Stack>
        )
    }
}